import { useMemo } from 'react';

import { useMediaQuery } from '@zoomit/primitives';
import type { MenuData, MenuItemType } from '@zoomit/web-kit';

type Props = {
  items: MenuData['items'];
};

export const useResponsiveMenu = ({ items }: Props) => {
  const isLgScreen = useMediaQuery({
    minWidth: 'lg',
  });

  const isXlScreen = useMediaQuery({
    minWidth: 'xl',
  });

  const isXXlScreen = useMediaQuery({
    minWidth: 'xxl',
  });

  let selectedItemThreshold = items.length;

  if (isXXlScreen) {
    selectedItemThreshold = items?.length;
  } else if (isXlScreen) {
    selectedItemThreshold = items?.length - 2;
  } else if (isLgScreen) {
    selectedItemThreshold = items?.length - 4;
  }

  const moreItemColumns = useMemo(() => {
    const clonedItems = structuredClone(items);

    return clonedItems.slice(selectedItemThreshold) as MenuItemType[];
  }, [items, isXXlScreen, isXlScreen, isLgScreen]);

  return {
    moreItemColumns,
  };
};
